import {getTestProps} from '@benchling/js-test-utils';
import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React, {useRef} from 'react';
import {ReactFlow, ReactFlowProvider} from 'reactflow';

import ReactFlowWrapper from 'processes/graph-builder/flowchart-viz/ReactFlowWrapper';
import DefaultBackground from 'ui-library/reactflow/backgrounds/DefaultBackground';
import HorizontalControls from 'ui-library/reactflow/controls/HorizontalControls';
import {useDefaultReactFlowProps} from 'ui-library/reactflow/ReactFlowConstants';

export interface ExecutionFlowchartPaneProps {
  processTaskSchemaId: string;
  processTaskSchemaName: string;
}

function ExecutionFlowchartPaneContent(props: ExecutionFlowchartPaneProps): JSX.Element {
  const defaultReactFlowProps = useDefaultReactFlowProps();
  const reactFlowWrapper = useRef<HTMLDivElement>(null);

  return (
    <div
      className={css(styles.paneWrapper)}
      {...getTestProps({component: 'ExecutionFlowchartPane', element: 'root'})}
    >
      <div className={css(styles.contentWrapper)}>
        <div className={css(styles.canvasContainer)}>
          <ReactFlowWrapper fullWidth={true}>
            <div className={css(styles.reactFlowContainer)} ref={reactFlowWrapper}>
              {/* TODO: Replace with flowchart editor component - stubbing for visual testing */}
              <ReactFlow
                {...defaultReactFlowProps}
                nodes={[]}
                edges={[]}
                nodesDraggable={true}
                nodesConnectable={true}
                elementsSelectable={true}
                fitView={true}
                panOnScroll={true}
                panOnDrag={true}
                zoomOnScroll={true}
                zoomOnPinch={true}
              >
                <DefaultBackground />
                <HorizontalControls />
              </ReactFlow>
            </div>
          </ReactFlowWrapper>
        </div>
      </div>
    </div>
  );
}

export default function ExecutionFlowchartPane(props: ExecutionFlowchartPaneProps): JSX.Element {
  return (
    <ReactFlowProvider>
      <ExecutionFlowchartPaneContent {...props} />
    </ReactFlowProvider>
  );
}

const styles = StyleSheet.create({
  paneWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  contentWrapper: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
    position: 'relative',
  },
  canvasContainer: {
    flex: 1,
    height: '100%',
    backgroundColor: Color.GRAY_100,
    position: 'relative',
  },
  reactFlowContainer: {
    height: '100%',
    width: '100%',
  },
});
